import { env } from 'next-runtime-env';

import type { RegionArea } from '@core/Entities/Location/RegionArea.entity';
import { fetchJson } from '@core/Utils/Fetch/FetchJson';

import type { FilterParams } from '../../../Entities/Search/QueryParams.entity';

export const getLocationFromSlug = async (locationStr?: string) => {
  const output: FilterParams = {};
  if (!locationStr) return output;

  const response = await fetchJson<{ AREAS: RegionArea[] }>(`${env('INTERNAL_URL')}/api/uk/areas`);
  const areas = response?.AREAS;
  if (!areas) return output;

  const matchingArea = areas.find(areaObj => areaObj.id === locationStr);
  if (matchingArea) {
    const areaPostcode = matchingArea.postcode;
    output.area = locationStr;
    output.postcode = areaPostcode;
  }

  return output;
};
